/* @flow */
import * as React from "react";
import { connect, type MapStateToProps } from "react-redux";
import { ThemeProvider } from "styled-components";
import { inferLocale } from "../components/common/Gettext";

import type { State } from "../redux/reducer";

type Props = {
  locale: string,
  children: React.Node
};

const RtlProvider = ({ locale, children }: Props) => (
  <ThemeProvider
    theme={{
      direction: locale === "ar" ? "rtl" : "ltr",
      locale
    }}
  >
    {children}
  </ThemeProvider>
);

const mapStateToProps = (state: State) => ({
  locale: inferLocale(state)
});

export default connect((mapStateToProps: MapStateToProps<*, *, *>))(
  RtlProvider
);



// WEBPACK FOOTER //
// ./src/components/RtlProvider.js